import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {UserService} from '../../services/user.service';
import {AuthGuardService} from '../../services/auth-guard.service';


@Component({templateUrl: './init.html', styleUrls: ['./init.scss']})
export class InitComponent implements OnInit {
  public constructor(private router: Router, private auth: AuthGuardService) {}


  ngOnInit() {
    if (this.auth.loggedIn) {
      this.router.navigate(['home']);     
    } else {
      this.router.navigate(['login']);     
    }
  
  }
}


// WEBPACK FOOTER //
// ./src/app/pages/init/init.ts